import { render } from "./WelcomeModal.vue?vue&type=template&id=252613a4&scoped=true"
import script from "./WelcomeModal.vue?vue&type=script&lang=js"
export * from "./WelcomeModal.vue?vue&type=script&lang=js"

import "./WelcomeModal.vue?vue&type=style&index=0&id=252613a4&scoped=true&lang=css"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252613a4"]])

export default __exports__